/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersnav1Inputs */

const en_partnersnav1 = /** @type {(inputs: Partnersnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partners`)
};

const de_partnersnav1 = /** @type {(inputs: Partnersnav1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Partner`)
};

/**
* | output |
* | --- |
* | "Partners" |
*
* @param {Partnersnav1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersnav1 = /** @type {((inputs?: Partnersnav1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersnav1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersnav1(inputs)
	return de_partnersnav1(inputs)
});
export { partnersnav1 as "partnersNav" }